import { SupplierOrderConfirmation } from './SupplierOrderConfirmation';
import { supplierOrderDocumentText } from '@/lib/supplierMaterialOrders';
import { materialOrderDocumentText } from '@/lib/productionMaterialPlanning';
import React from 'react';
import { readMaterialOrder } from '@/lib/api/materialOrders';
export function MaterialOrderPublicView({ token }) {
  const [model, setModel] = React.useState(null);
  const [error, setError] = React.useState('');
  const [saved, setSaved] = React.useState(false);
  const confirmationRef = React.useRef(null);
  const confirmed = Boolean(model?.supplier_confirmed_at);
  React.useEffect(() => {
    if (saved) {
      confirmationRef.current?.scrollIntoView({ block: 'center', behavior: 'smooth' });
      confirmationRef.current?.focus({ preventScroll: true });
    }
  }, [saved]);
  React.useEffect(() => {
    let active = true;
    setModel(null); setError(''); setSaved(false);
    readMaterialOrder(token).then(value => { if (active) setModel(value); }).catch(e => { if (active) setError(e.message); });
    return () => { active = false; };
  }, [token]);
  return <main className="mx-auto max-w-2xl space-y-4 p-6"><h1 className="text-2xl font-semibold">Pedido de materiales</h1>
    {error ? <p role="alert">{error}</p> : !model ? <p>Cargando pedido…</p> : <>
      <p>Registrado: {new Date(model.created_at).toLocaleString('es-ES')}</p>
      <pre className="whitespace-pre-wrap break-words rounded border p-4 font-sans">{model.lines ? supplierOrderDocumentText(model) : materialOrderDocumentText(model)}</pre>
      {(saved || confirmed) && <p ref={confirmationRef} tabIndex={-1} role="status" className="rounded bg-green-100 p-3 text-green-900">Confirmación enviada. Las cantidades de todas las líneas han quedado registradas. Este pedido ya no admite nuevos envíos. Si necesitas corregirlo, contacta con quien te lo ha enviado.</p>}
      {model.lines ? !confirmed && !saved && <SupplierOrderConfirmation key={`${token}:${model.lines.map(l => l.confirmation_revision).join(',')}`} order={model} token={token} onSaved={result => { setModel(result); setSaved(true); }} /> : <p className="text-sm">Pedido individual anterior. Para confirmar disponibilidad o entrega, contacta con quien te lo ha enviado.</p>}
      <button className="mr-3 text-blue-700 underline print:hidden" onClick={async () => { try { setModel(await readMaterialOrder(token)); setError(''); } catch (e) { setError(e.message); } }}>Actualizar pedido</button>
      <button className="rounded bg-blue-700 px-4 py-2 text-white print:hidden" onClick={() => window.print()}>Imprimir pedido</button>
    </>}
  </main>;
}
